import React from 'react';

import { Modal } from 'ui/modal/modal.ui';

import { Content } from './modal-use-terms.styles';

interface ModalUseTermsProps {
  show: boolean;
  toggle: () => void;
}

export const ModalUseTerms = ({ show, toggle }: ModalUseTermsProps) => (
  <Modal
    show={show}
    size="xl"
    title="Termos e Condições de Uso da Plataforma"
    close={toggle}
  >
    <Content>
      <p>
        Bem-vindo(a) ao <b>EnergyPass</b>, plataforma de dados com relatórios
        precisos e insights para eficiência energética. Esta plataforma é de
        propriedade, mantida e operada por{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>, inscrita no
        CNPJ 49.076.630/0001-39, com sede na Rua Uirapuru, n° 615 – Letra B,
        Jardim São Gonçalo, Campinas/SP, e com endereço de e-mail
        energypass@solsticioenergia.com. Ao cadastrar, acessar e utilizar esta
        plataforma, você concorda em cumprir e ficar vinculado aos seguintes
        Termos e Condições de Uso. Se você não concordar com algum aspecto
        destes Termos, por favor, não utilize nossa plataforma.
      </p>
      <p>
        O EnergyPass faculta acesso e utilização da plataforma a quaisquer
        usuários cadastrados.{' '}
        <u>
          De modo que, o Usuário declara ter lido e aceito estes Termos e
          Condições de Uso e das Políticas antes de ter iniciado a utilização da
          plataforma. Caso o Usuário não aceite estes Termos e Condições de Uso,
          não lhe será permitido acesso a áreas restritas da plataforma
        </u>
        .
      </p>
      <h3>1. Para fins de definição</h3>
      <p>
        <u>Usuário(s)</u>: todos aqueles, pessoas físicas ou jurídicas, que
        preencheram o cadastro e detêm uma Conta de Acesso na Plataforma;
      </p>
      <p>
        <u>Conta de Acesso</u>: credencial definida pelo nome de usuário (login)
        e senha de um usuário, pessoal e intransferível, que permite acesso à
        área restrita e às funcionalidades exclusivas da Plataforma, tais como:
        acesso e alteração de dados pessoais, inscrição e cancelamento de planos
        adicionais, upload e download de documentos (em especial, documentos
        para cadastro de Unidades Consumidoras), emissão de boletos e/ou
        alteração de forma de pagamento, comunicação direta com o suporte da
        plataforma para correção manual de eventuais erros, apresentação de
        relatórios e resultados, entre outras;
      </p>
      <p>
        <u>Plataforma</u>: tecnologia para suportar a execução de tarefas e
        facilitar o processo de gestão das Unidades Consumidoras dos Usuários,
        bem como as funcionalidades dos Planos Adicionais, mantida e operada
        pela empresa <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>.
        Tal tecnologia engloba o Site, bem como eventual Aplicativo.
      </p>
      <p>
        <u>Aplicativo</u>: programa de software desenvolvido para ser utilizado
        em dispositivos móveis, mantido e operado por{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>.
      </p>
      <p>
        <u>Site</u>: o website de propriedade, mantido e operado por{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>, hospedado no
        domínio https://energypass.com.br/ e todas as páginas nele
        compreendidas;
      </p>
      <p>
        <u>Unidades Consumidoras</u>: são as contas de energia elétrica
        existentes em nome do Usuário. O EnergyPass não se obriga e não se
        responsabiliza pelo tratamento de dados de Unidades Consumidoras que não
        estejam em nome do Usuário ou que não estejam relacionadas a
        distribuidoras de energia não atendidas pela Plataforma. Para serviços
        pagos disponibilizados na Plataforma, poderá, eventualmente, ser
        disponibilizada a critério do EnergyPass, a possibilidade de adicionar
        Unidades Consumidoras de titularidade de terceiros.
      </p>
      <p>
        <u>Planos Adicionais</u>: quaisquer serviços e/ou funcionalidades que
        possam vir a ser contratados através da Plataforma de forma gratuita ou
        não.
      </p>
      <p>
        <u>Propriedade Intelectual</u>: restringe a todos os bens de propriedade
        intelectual de titularidade da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>, e de qualquer
        empresa pertencente a seu grupo econômico, ou, ainda, de terceiro, cujo
        uso seja licenciado e/ou autorizado à{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>, incluindo, mas
        não se limitando, a Marcas, patentes, invenções ou modelos de utilidade,
        desenhos industriais, know-how, segredos de negócio, ilustrações,
        fotografias e/ou conteúdos de qualquer tela da Plataforma ou quaisquer
        obras intelectuais ou outros conteúdos que estejam inseridos em qualquer
        obra intelectual ou qualquer bem protegido por direitos de propriedade
        intelectual;
      </p>
      <p>
        <u>Marca(s)</u>: quaisquer sinais distintivos de titularidade da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>, que sejam
        utilizados na identificação da plataforma, de seu conteúdo ou de serviço
        prestado por ela;
      </p>
      <p>
        <u> Políticas</u>: as políticas que complementam e integram estes Termos
        e Condições de Uso, a Política de Privacidade e Segurança, todas
        disponíveis na Plataforma;
      </p>

      <h3>2. Regras de utilização da Plataforma:</h3>

      <p>
        O Usuário obriga-se a utilizar a Plataforma respeitando e observando
        estes Termos e Condições de Uso, bem como a legislação vigente, os
        costumes e a ordem pública. Desta forma, o Usuário concorda que{' '}
        <b>não poderá</b>: (i) lesar direitos de terceiros, independentemente de
        sua natureza, em qualquer momento, inclusive no decorrer do uso da
        Plataforma; (ii) executar atos que limitem ou impeçam o acesso e a
        utilização do Plataforma, em condições adequadas, aos demais Usuários;
        (iii) acessar ilicitamente a Plataforma ou sistemas informáticos de
        terceiros relacionados a Plataforma ou à{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> sob qualquer
        meio ou forma; (iv) difundir programas ou vírus informáticos suscetíveis
        de causar danos de qualquer natureza, inclusive em equipamentos e
        sistemas da <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> ou
        de terceiros; (v) utilizar mecanismos que não os expressamente
        habilitados ou recomendados no Site para obtenção de informações,
        conteúdos e serviços; (vi) realizar quaisquer atos que de alguma forma
        possam implicar qualquer prejuízo ou dano à ENERGY PASS CONSULTORIA E
        GESTAO DE ENERGIA LTDA ou a outros Usuários; (vii) acessar áreas de
        programação da Plataforma, bases de dados ou qualquer outro conjunto de
        informações que escape às áreas públicas ou restritas do Site; (viii)
        realizar ou permitir engenharia reversa, traduzir, modificar, alterar a
        linguagem, compilar, decompilar, modificar, reproduzir, alugar,
        sublocar, divulgar, transmitir, distribuir, usar ou, de outra maneira,
        dispor do Site ou das ferramentas e funcionalidades nele
        disponibilizadas sob qualquer meio ou forma, inclusive de modo a violar
        direitos da <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>{' '}
        (inclusive de Propriedade Intelectual desta e/ou de terceiros ou ainda
        de qualquer lei aplicável, ou agir sob qualquer meio ou forma que possa
        contribuir com tal violação); (ix) interferir na segurança ou cometer
        usos indevidos contra a Plataforma ou qualquer recurso do sistema, rede
        ou serviço conectado ou que possa ser acessado por meio do Site, devendo
        acessar a Plataforma apenas para fins lícitos e autorizados; (x)
        utilizar o domínio da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> para criar links
        ou atalhos a serem disponibilizados em e-mails não solicitados
        (mensagens spam) ou em websites de terceiros ou do próprio Usuário ou,
        ainda, para realizar qualquer tipo de ação que possa vir a prejudicar a{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> ou terceiros;
        (xi) utilizar aplicativos automatizados de coleta e seleção de dados
        para realizar operações massificadas ou para quaisquer finalidades ou,
        ainda, para coletar e transferir quaisquer dados que possam ser
        extraídos da Plataforma para fins não permitidos ou ilícitos, (xii){' '}
        <u>
          utilizar as ferramentas e funcionalidades da Plataforma para difundir
          mensagens não relacionadas com os serviços oferecidos pela Plataforma
          ou com as finalidades do Site ou Aplicativo, incluindo mensagens de
          cunho racista, étnico, político, religioso, cultural ou depreciativo,
          difamatório e/ou calunioso de qualquer pessoa ou grupo social
        </u>
        .
      </p>
      <p>
        O Usuário concorda em indenizar, defender e isentar a{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> de qualquer
        reclamação, notificação, intimação ou ação judicial ou extrajudicial, ou
        ainda de qualquer responsabilidade, dano, custo ou despesa decorrente de
        qualquer violação e/ou infração cometida pelo Usuário ou qualquer pessoa
        agindo em seu nome, com seu consentimento ou tolerância, em relação à
        Plataforma (inclusive com relação a qualquer disposição destes Termos e
        Condições de Uso), inclusive qualquer pessoa que tenha obtido os dados
        do Usuário relacionados a sua Conta de Acesso ou a sua navegação na
        Plataforma.
      </p>
      <p>
        A <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> poderá, a seu
        exclusivo critério, bloquear, restringir, desabilitar ou impedir o
        acesso de qualquer Usuário à plataforma, total ou parcialmente, sem
        qualquer aviso prévio, sempre que for detectada uma conduta inadequada
        do Usuário, sem prejuízo das medidas administrativas, extrajudiciais e
        judiciais que julgar convenientes.
      </p>
      <h3>3. Cadastro de usuários e fornecimento de dados:</h3>
      <p>
        <u>
          O cadastro do Usuário será feito através do fornecimento de alguns
          dados de acordo com o disposto na Política de Proteção de Dados
        </u>
        .
      </p>
      <p>
        <u>
          O Usuário declara e garante que possui todas as autorizações e
          licenças necessárias para submeter via Plataforma os dados detidos e
          garante não infringir direitos de propriedade intelectual realizados a
          marca e de terceiros
        </u>
        .
      </p>
      <p>
        Para obter acesso ao conteúdo completo as ferramentas e funcionalidades
        da Plataforma, o Usuário deverá criar uma Conta de Acesso, local em que
        serão armazenados os Dados Pessoais do Usuário e utilizados para
        identificação dos atos, a serem tratados nos termos da Política de
        Privacidade e Segurança, ressaltando-se que a criação de cada Conta
        pressupõe o consentimento expresso sobre coleta, uso, armazenamento e
        tratamento de dados pessoais pela{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> e/ou por
        terceiros por ela contratados para realizar qualquer procedimento ou
        processo relacionado às funcionalidades da Plataforma.
      </p>
      <p>
        A cada Usuário é permitida a criação de inúmeras Contas de Acesso e a{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> se reserva o
        direito de suspender ou cancelar quaisquer Contas de Acesso em
        duplicidade. Ao completar a sua Conta de Acesso, o Usuário declara que
        as informações fornecidas são completas, verdadeiras, atuais e precisas,
        sendo de total responsabilidade deste a atualização dos dados de sua
        Conta de Acesso sempre que houver modificação de nome, endereço ou
        qualquer outra informação relevante.
      </p>
      <p>
        A <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> também poderá
        recusar, suspender ou cancelar a Conta de Acesso de um Usuário sempre
        que suspeitar que as informações fornecidas são falsas, incompletas,
        desatualizadas ou imprecisas ou ainda nos casos indicados nas leis e
        regulamentos aplicáveis, nestes Termos e Condições ou em qualquer
        Política da Plataforma, mesmo que previamente aceito. O Usuário, no
        momento da criação de sua Conta de Acesso, determinará seu nome de
        Usuário e sua senha de acesso.
      </p>
      <p>
        É de exclusiva responsabilidade do Cliente a manutenção do sigilo do
        nome de usuário e/ou da senha de acesso relativos à sua Conta de Acesso,
        devendo o usuário comunicar imediatamente a{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> em caso de
        perda, divulgação ou roubo da senha ou ainda de uso não autorizado de
        sua Conta. Menores (idade inferior a 18 anos) não poderão utilizar a
        Plataforma, a menos que sejam representados e/ou assistidos por seus
        pais ou responsáveis legais e por estes autorizados no momento da
        criação da Conta.
      </p>
      <h3>4. Dados pessoais, privacidade e segurança:</h3>
      <p>
        O Usuário poderá fazer a atualização de dados das Unidades Consumidoras
        de forma manual através do upload de documentos ou através da concessão
        a Plataforma <b>EnergyPass</b> do login e senha vinculados as contas de
        energia da plataforma utilizada pela distribuidora de energia e também
        do sistema de monitoramento do sistema fotovoltaico, de modo a
        compatibilizar informações entre plataformas.
      </p>
      <p>
        A <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> dispõe de uma
        Política específica para regular a coleta, guarda e utilização de dados
        pessoais, bem como a sua segurança: Política de Privacidade e Segurança.
        Essa Política específica integra inseparavelmente estes Termos e
        Condições de Uso, ressaltando-se que os dados de utilização da
        Plataforma serão arquivados nos termos da legislação em vigor.
      </p>
      <h3>5. Planos Adicionais:</h3>
      <p>
        A <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>{' '}
        disponibilizará na Plataforma, para cada Plano Adicional, uma página
        descritiva, da qual constarão informações relativas aos serviços e/ou
        produtos que poderão ser contratados, de forma gratuita ou onerosa, pelo
        Usuário, bem como informações básicas de uso.
      </p>
      <p>
        Os Planos Adicionais se vincularão, sem exceção, ao presente “Termo e
        Condições de Uso da Plataforma”.
      </p>
      <h3>6. Responsabilidades:</h3>
      <p>
        A <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> engaja seus
        melhores esforços para informar, atender e proteger o Usuário. O Usuário
        é o único responsável pela utilização da Plataforma, de suas ferramentas
        e funcionalidades. Em nenhuma hipótese, a{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> ou seus
        diretores, representantes, agentes, empregados, sócios, parceiros,
        prestadores de serviço ou grupo econômico, serão responsabilizados por
        qualquer dano emergente, indireto, punitivo ou expiatório, lucros
        cessantes ou outros prejuízos monetários relacionados a qualquer
        reclamação, ação judicial ou outro procedimento tomado em relação à má
        utilização da Plataforma, seu conteúdo, funcionalidades e/ou
        ferramentas. Notadamente, fica excluída a responsabilidade da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> sobre as
        seguintes circunstâncias, entre outras: (i) danos e prejuízos que o
        Usuário possa experimentar pela indisponibilidade ou funcionamento
        parcial do Site e/ou de todos ou alguns de seus serviços, informações,
        conteúdos, funcionalidade e/ou ferramentas, bem como pela incorreção ou
        inexatidão de qualquer destes elementos; (ii) danos e prejuízos que o
        Usuário possa experimentar em sites de internet acessíveis por links
        incluídos na plataforma; (iii) danos e prejuízos que o Usuário possa
        experimentar em decorrência do uso da Plataforma em desconformidade com
        estes Termos e Condições de Uso ou com as Políticas; (iv) danos e
        prejuízos que o Usuário possa experimentar em decorrência do uso da
        Plataforma em desconformidade com a lei, com os costumes ou com a ordem
        pública; (iv) danos e prejuízos que o Usuário possa experimentar em
        decorrência de falhas na Plataforma, inclusive decorrentes de falhas no
        sistema, no servidor ou na conexão de rede, ou ainda de interações
        maliciosas como vírus, softwares que possam danificar o equipamento ou
        acessar informações do equipamento do Usuário.
      </p>
      <h3>7. Links para outros websites:</h3>
      <p>
        A plataforma pode conter links para sites de terceiros, os quais são
        inseridos apenas para conveniência do Usuário. A inclusão de tais links
        não implica qualquer vínculo, monitoramento ou responsabilidade da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>
        sobre os sites, respectivos conteúdo ou titulares. O acesso aos sites
        vinculados a tais links não é regido por esses Termos e Condições de Uso
        e não se encontra protegido pelas Políticas. A{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> recomenda que o
        Usuário consulte os termos e condições de uso estabelecidos por cada
        site vinculado aos links inseridos no Site. A{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> não será
        responsável, direta ou indiretamente, por quaisquer danos ou prejuízos
        causados ou relacionados à utilização de qualquer informação, conteúdo,
        bens ou serviços disponibilizados no Site ou em qualquer site de
        terceiros acessado por meio dos links disponibilizados no Site.
      </p>
      <h3>8. Direitos de Propriedade Intelectual:</h3>
      <p>
        <u>Marcas</u>: O Usuário não está autorizado a utilizar, sob qualquer
        forma ou pretexto, as Marcas, suas reproduções parciais ou integrais ou
        ainda suas imitações, independentemente da destinação de tal uso. O
        Usuário compromete-se a não contestar a validade de qualquer Marca ou de
        qualquer outro sinal distintivo depositado ou registrado pela{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> ou por quaisquer
        empresas a ela vinculadas, sob qualquer forma, no Brasil ou no exterior.
        O Usuário compromete-se a se abster de fazer qualquer uso das Marcas ou
        de suas variações (incluindo erros de ortografia ou variações fonéticas)
        como nome de domínio ou parte de nome de domínio ou em qualquer nome de
        empresa, de qualquer tipo ou natureza, sob qualquer meio ou forma,
        inclusive por meio da criação de nomes de domínio ou e-mails. Todas as
        outras marcas, nomes de produtos, ou nomes de companhias que aparecem no
        Plataforma são de propriedade exclusiva de seus respectivos titulares.
      </p>
      <p>
        <u>Propriedade do conteúdo</u>: Todo o conteúdo relativo a Plataforma e
        suas funcionalidades, programas, bases de dados, arquivos, textos,
        fotos, layouts, cabeçalhos e demais elementos - foi criado, desenvolvido
        ou cedido pela <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>,
        sendo, portanto, de propriedade dela ou a ela licenciado e encontra-se
        protegido pelas leis brasileiras e tratados internacionais que versam
        sobre direitos de propriedade intelectual.
      </p>
      <p>
        <u>Proibição de utilização</u>: O Usuário, ao acessar a plataforma,
        atesta que respeitará a existência e a extensão dos direitos de
        Propriedade Intelectual da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>, bem como de
        todos os direitos de terceiros que sejam usados, a qualquer título, na
        Plataforma ou que venham a ser disponibilizados nela. O acesso ao Site
        ou Aplicativo e a sua regular utilização pelo Usuário não lhe confere
        qualquer direito ou prerrogativa sobre o qualquer Propriedade
        Intelectual, Marca ou outro conteúdo nele inserido. É vedada a
        utilização, exploração, imitação, reprodução, integral ou parcial, de
        qualquer conteúdo sem a autorização prévia e por escrito da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>.
      </p>
      <p>
        É igualmente vedada a criação de quaisquer obras derivadas de qualquer
        Propriedade Intelectual da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> sem a
        autorização prévia e por escrito da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>.
      </p>
      <p>
        É expressamente proibido ao Usuário reproduzir, distribuir, modificar,
        exibir e criar trabalhos derivados ou qualquer outra forma de utilização
        de qualquer Propriedade Intelectual ou outro conteúdo desta plataforma,
        inclusive, dos materiais veiculados a ela.
      </p>
      <p>
        <u>Penalidade</u>: O Usuário que violar as proibições contidas na
        legislação sobre Propriedade Intelectual e nestes Termos e Condições de
        Uso serão responsabilizados, civil e criminalmente, pelas infrações
        cometidas. A <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> não
        concede nenhuma autorização relacionada ao conteúdo da Plataforma para
        qualquer fim. O Usuário assume toda e qualquer responsabilidade pela
        utilização indevida de qualquer Propriedade Intelectual ou Marcas da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> ou de terceiros,
        tanto de caráter civil quanto criminal.
      </p>
      <p>
        <u>Conteúdo enviado pelo usuário</u>: Ao enviar qualquer conteúdo à
        Plataforma, o usuário retém a titularidade de seus direitos sobre dito
        conteúdo (textos, vídeos, imagens, áudio, informações gráficas, desenhos
        e entre outros), cedendo à{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> uma licença de
        caráter gratuito, irrevogável, mundial e não exclusivo para a
        reprodução, modificação, tradução, exibição, e tratamento do dado, sob
        qualquer meio ou forma, inclusive na{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> declarando,
        ainda, o usuário ser titular de todos os direitos relacionados ao
        referido conteúdo.
      </p>
      <h3>9. Comunicações e Central de Atendimento:</h3>
      <p>
        A <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> disponibiliza
        um Canal de Atendimento para receber todas as comunicações que o Usuário
        desejar fazer. A Central de Atendimento opera por meios dos canais de
        comunicação listados abaixo:
      </p>
      <p>
        (a) Através do e-mail: <b>energypass@solsticioenergia.com</b> sempre
        acompanhada das informações de contato do Usuário, tal como nome
        completo, CPF e e-mail cadastrado, para que possamos prosseguir
        adequadamente com o atendimento.
      </p>
      <p>
        (b) Através do Serviço de Atendimento pelo WhatsApp{' '}
        <b>(19) 97108-1263.</b>
      </p>
      <p>
        Em todos os casos, o Usuário receberá, pelo mesmo canal de comunicação,
        uma confirmação do recebimento da sua demanda, que será tratada e
        respondida em um prazo máximo de 5 (cinco) dias úteis. Da mesma forma,
        todas as comunicações que a{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> desejar fazer ao
        Usuário deverão ser realizadas por meio do e-mail cadastrado ou
        utilizado pelo Usuário. Excepcionalmente, a{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> poderá
        comunicar-se com o Usuário por outros meios de comunicação, como
        telefone celular, SMS, MMS, aplicativos de mensagens ou correspondência
        física, desde que fornecidos pelo Usuário.
      </p>
      <h3>10. Duração:</h3>
      <p>
        Estes Termos e Condições de Uso, bem como as Políticas têm duração
        indeterminada e permanecerão em vigor enquanto a Plataforma estiver
        ativa. Dessa forma, o acesso e a utilização da Plataforma e dos recursos
        por ela oferecidos têm, em princípio, duração igualmente indeterminada,
        a exclusivo critério da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>.
      </p>
      <h3>11. Atualização dos Termos e Condições:</h3>
      <p>
        A <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> poderá
        unilateralmente revisar, aprimorar, modificar e/ou atualizar, a qualquer
        momento, sem necessidade de qualquer aviso prévio, qualquer cláusula ou
        disposição contidas nestes Termos e Condições de Uso ou nas Políticas. A
        versão atualizada valerá para o uso da Plataforma e para todos os atos e
        providências gerados a partir dela. A continuidade de acesso ou
        utilização desta Plataforma, depois da divulgação de quaisquer
        modificações, confirmará a aceitação dos novos Termos e Condições de Uso
        ou das novas Políticas pelos Usuários. Caso um usuário não esteja de
        acordo com uma determinada alteração das Políticas ou dos Termos e
        Condições de Uso, poderá rescindir seu vínculo com a{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> por meio de
        pedido de exclusão da Conta de Acesso da Plataforma ou mediante contato
        com a Central de Atendimento da{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>. Esta rescisão
        não eximirá, no entanto, o Usuário de cumprir com todas as obrigações
        assumidas sob as versões precedentes das Políticas, dos Termos e
        Condições de Uso e/ou dos Planos Adicionais contratados.
      </p>

      <h3>12. Demais disposições:</h3>

      <p>
        <u>Aplicabilidade parcial</u>: Caso a{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> não consiga
        fazer valer ou cumprir qualquer cláusula ou condição contida nestes
        Termos e Condições de Uso ou nas Políticas, tal fato não configurará
        desistência, tolerância ou novação dessa cláusula ou condição destes
        Termos ou de qualquer Política. Se alguma cláusula ou condição contida
        nestes Termos e Condições de Uso ou nas Políticas for declarada
        inexequível, no todo ou parcialmente, tal inexequibilidade não afetará
        as demais cláusulas dos Termos e Condições de Uso e das Políticas. Neste
        caso, a <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> fará as
        adaptações necessárias para que reflitam, da forma mais próxima
        possível, os termos da provisão declarada inexequível.
      </p>
      <p>
        <u>Caso fortuito e força maior</u>: Nenhuma das Partes será
        responsabilizada perante a outra quando o descumprimento ou o
        cumprimento extemporâneo de uma obrigação prevista nas Políticas ou
        nestes Termos e Condições de Uso for causado por casos fortuitos ou
        eventos de força maior, enquanto perduraram as suas consequências.
      </p>
      <p>
        <u>Princípio de respeito aos Usuários</u>: A{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> tem como
        princípio de sua atuação nos ambientes físicos e virtuais o respeito ao
        Usuário, agindo sempre em conformidade com as disposições do Código de
        Proteção e Defesa do Consumidor (Lei Federal n. 8078/90), do Marco Civil
        da Internet (Lei Federal n. 12965/14) e da Lei Geral de Proteção de
        Dados (Lei no 13.709/2018).
      </p>

      <h3>13. Lei Aplicável e Foro de Eleição:</h3>

      <p>
        O Site e Aplicativo será controlado, operado e administrado pela{' '}
        <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b> na cidade de
        Campinas, Estado de São Paulo, Brasil, podendo ser acessado por qualquer
        dispositivo conectado à Internet, independentemente de sua localização
        geográfica. Em vista das diferenças que podem existir entre as
        legislações locais e nacionais, ao acessar o Site e/ou Aplicativo, o
        Usuário concorda que a legislação aplicável para fins destes Termos e
        Condições de Uso será aquela vigente em território brasileiro.
      </p>
    </Content>
  </Modal>
);
